import script from "./DesignDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignDetailView.vue?vue&type=script&setup=true&lang=js"

import "./DesignDetailView.vue?vue&type=style&index=0&id=547f9bd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547f9bd6"]])

export default __exports__